import {BaseError} from './base-error';

export class NotImplementedError extends BaseError {
  public constructor() {
    super('Method not implemented');
  }
}
